import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "@/views/LoginPage.vue";
import AssetsPage from "@/views/AssetsPage.vue";
import DepartmentsPage from "@/views/DepartmentsPage.vue";
import UsersPage from "@/views/UsersPage.vue";
import SoftwarePage from "@/views/SoftwarePage.vue";
import MaintenancesPage from "@/views/MaintenancesPage.vue";
import MaintenanceDetail from "@/views/MaintenanceDetail.vue";
import HomePage from "@/views/HomePage.vue";
import WorkPositionsPage from "@/views/WorkPositionsPage.vue";
import LocationPage from "@/views/LocationPage.vue";
import RoomPage from "@/views/RoomPage.vue";
import SmallAsset from "@/views/SmallAsset.vue";
import ControlPanel from "@/views/ControlPanel.vue";
import ReportsPage from "@/views/ReportsPage.vue";
import KategorijePage from "@/views/KategorijePage.vue";
import KomisijePage from "@/views/KomisijePage.vue";
import PopisPage from "@/views/PopisPage.vue";
import PopisPreviewPage from "@/views/PopisPreviewPage.vue";
import Public from "@/views/Public.vue";
import SuperAdminClients from "@/views/SuperAdminClients.vue";
import Camera from "@/views/CameraView.vue";

const routes = [
  {
    path: "/",
    name: "Public",
    component: Public,
    meta: { layout: 'none' },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { layout: 'none' },
  },
  {
    path: "/home",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/user",
    name: "Users",
    component: UsersPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/location",
    name: "Locations",
    component: LocationPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/room",
    name: "Rooms",
    component: RoomPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/categories",
    name: "Categories",
    component: KategorijePage,
    meta: { requiresAuth: true },
  },

  {
    path: "/komisije",
    name: "Komisije",
    component: KomisijePage,
    meta: { requiresAuth: true },
  },

  {
    path: "/asset",
    name: "Assets",
    component: AssetsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/software",
    name: "Softwares",
    component: SoftwarePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/smallAsset",
    name: "Small Assets",
    component: SmallAsset,
    meta: { requiresAuth: true },
  },
  {
    path: "/reports",
    name: "Reports Page",
    component: ReportsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/control-panel",
    name: "Control Panel",
    component: ControlPanel,
    meta: { requiresAuth: true },
  },
    {
    path: "/popis",
    name: "Popis",
    component: PopisPage,
    meta: { requiresAuth: true },
  },
      {
    path: "/popisPreview/:id",
    name: "PopisPreview",
    component: PopisPreviewPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/maintenance",
    name: "Maintenenaces",
    component: MaintenancesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/maintenance/:id",
    name: "maintenance-detail",
    component: MaintenanceDetail,
    meta: { requiresAuth: true },
    props: true,
  },

  {
    path: "/department",
    name: "Departments",
    component: DepartmentsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/workposition',
    name: "Work-positions",
    component: WorkPositionsPage,
    meta: { requiresAuth: true },
  },
  {
  path: "/superadmin/clients",
  name: "SuperAdminClients",
  component: SuperAdminClients,
  meta: { requiresAuth: true },
},
{
    path: '/camera',
    name: "Camera",
    component: Camera,
    meta: { requiresAuth: true },
  },
  {
    path: '/asset-investments/:assetId',
    name: 'AssetInvestments',
    component: () => import('@/views/AssetInvestments.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('Token');

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: "Login" });
  } else {
    next();
  }
});
export default router;
